import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ceba1ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ShippingHistoryDetail" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ShippingHistoryDetail_Header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "ShippingHistoryDetail_HeaderTitle" })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ShippingHistoryDetail_Main" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ShippingHistoryDetail_TableContainer" })
], -1))
const _hoisted_4 = { class: "ShippingHistoryDetail_Top" }
const _hoisted_5 = { class: "ShippingHistoryDetail_TopWrapper" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ShippingHistoryDetail_TopWrapper_Title" }, " 出庫履歴照会(明細) ", -1))
const _hoisted_7 = { class: "ShippingHistoryDetail_TopWrapper_Container" }
const _hoisted_8 = { class: "ShippingHistoryDetail_TopWrapper_Content" }
const _hoisted_9 = { class: "ShippingHistoryDetail_TopWrapper_List" }
const _hoisted_10 = { class: "ShippingHistoryDetail_TopWrapper_ListItem" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ShippingHistoryDetail_ListTitle" }, "受注番号", -1))
const _hoisted_12 = { class: "ShippingHistoryDetail_ListContent" }
const _hoisted_13 = { class: "ShippingHistoryDetail_TopWrapper_ListItem" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ShippingHistoryDetail_ListTitle" }, "登録日付", -1))
const _hoisted_15 = { class: "ShippingHistoryDetail_ListContent" }
const _hoisted_16 = { class: "ShippingHistoryDetail_TopWrapper_List" }
const _hoisted_17 = { class: "ShippingHistoryDetail_TopWrapper_ListItem" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ShippingHistoryDetail_ListTitle" }, "依頼者", -1))
const _hoisted_19 = { class: "ShippingHistoryDetail_ListContent" }
const _hoisted_20 = { class: "ShippingHistoryDetail_TopWrapper_ListItem" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ShippingHistoryDetail_ListTitle" }, "登録者", -1))
const _hoisted_22 = { class: "ShippingHistoryDetail_ListContent" }
const _hoisted_23 = { class: "ShippingHistoryDetail_TopWrapper_List" }
const _hoisted_24 = { class: "ShippingHistoryDetail_TopWrapper_ListItem" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ShippingHistoryDetail_ListTitle" }, "イベント", -1))
const _hoisted_26 = { class: "ShippingHistoryDetail_ListContent" }
const _hoisted_27 = { class: "ShippingHistoryDetail_TopWrapper_List" }
const _hoisted_28 = { class: "ShippingHistoryDetail_TopWrapper_ListItem" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ShippingHistoryDetail_ListTitle" }, "取引条件", -1))
const _hoisted_30 = { class: "ShippingHistoryDetail_ListContent" }
const _hoisted_31 = { class: "ShippingHistoryDetail_TopWrapper_ListItem" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ShippingHistoryDetail_ListTitle" }, "サイクル", -1))
const _hoisted_33 = { class: "ShippingHistoryDetail_ListContent" }
const _hoisted_34 = { class: "ShippingHistoryDetail_TopWrapper_List" }
const _hoisted_35 = { class: "ShippingHistoryDetail_TopWrapper_ListItem" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ShippingHistoryDetail_ListTitle" }, "取次/取引先", -1))
const _hoisted_37 = { class: "ShippingHistoryDetail_ListContent" }
const _hoisted_38 = { class: "ShippingHistoryDetail_TopWrapper_ListItem" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ShippingHistoryDetail_ListTitle" }, "書店/納品先", -1))
const _hoisted_40 = { class: "ShippingHistoryDetail_ListContent" }
const _hoisted_41 = { class: "ShippingHistoryDetail_TopWrapper_Content" }
const _hoisted_42 = { class: "ShippingHistoryDetail_TopWrapper_List" }
const _hoisted_43 = { class: "ShippingHistoryDetail_TopWrapper_ListItem" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ShippingHistoryDetail_ListTitle" }, "短冊メモ", -1))
const _hoisted_45 = { class: "ShippingHistoryDetail_ListContent_Large" }
const _hoisted_46 = { class: "ShippingHistoryDetail_TopWrapper_List" }
const _hoisted_47 = { class: "ShippingHistoryDetail_TopWrapper_ListItem" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ShippingHistoryDetail_ListTitle" }, "納品書備考", -1))
const _hoisted_49 = { class: "ShippingHistoryDetail_ListContent_Large" }
const _hoisted_50 = { class: "ShippingHistoryDetail_TopWrapper_List" }
const _hoisted_51 = { class: "ShippingHistoryDetail_TopWrapper_ListItem" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ShippingHistoryDetail_ListTitle" }, "作業備考", -1))
const _hoisted_53 = { class: "ShippingHistoryDetail_ListContent_Large" }
const _hoisted_54 = { class: "ShippingHistoryDetail_TopWrapper_List" }
const _hoisted_55 = { class: "ShippingHistoryDetail_TopWrapper_ListItem" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ShippingHistoryDetail_ListTitle" }, "書店コード", -1))
const _hoisted_57 = { class: "ShippingHistoryDetail_ListContent" }
const _hoisted_58 = { class: "ShippingHistoryDetail_TopWrapper_ListItem" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ShippingHistoryDetail_ListTitle" }, "番線/作業コード", -1))
const _hoisted_60 = { class: "ShippingHistoryDetail_ListContent" }
const _hoisted_61 = { class: "ShippingHistoryDetail_TopWrapper_List" }
const _hoisted_62 = { class: "ShippingHistoryDetail_TopWrapper_ListItem" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ShippingHistoryDetail_ListTitle" }, "本伝確定伝票NO", -1))
const _hoisted_64 = { class: "ShippingHistoryDetail_ListContent" }
const _hoisted_65 = { class: "ShippingHistoryDetail_TableContainer" }
const _hoisted_66 = { class: "ShippingHistoryDetail_Table" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "ShippingHistoryDetail_Table_Sticky_TH1" }, "明細No"),
    /*#__PURE__*/_createElementVNode("th", { class: "ShippingHistoryDetail_Table_Sticky_TH2" }, "商品番号"),
    /*#__PURE__*/_createElementVNode("th", { class: "TH_Large" }, "ISBN13桁"),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createTextVNode("出版書誌"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("コード")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "TH_Large" }, "商品名"),
    /*#__PURE__*/_createElementVNode("th", null, "本体価格"),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"65px"} }, "受注数"),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"65px"} }, "出庫数"),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"48px"} }, "正味"),
    /*#__PURE__*/_createElementVNode("th", null, "正味金額"),
    /*#__PURE__*/_createElementVNode("th", null, "搬入先"),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"85px"} }, "納品日付"),
    /*#__PURE__*/_createElementVNode("th", null, "納品番号"),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"85px"} }, "請求日付"),
    /*#__PURE__*/_createElementVNode("th", null, "短冊区分"),
    /*#__PURE__*/_createElementVNode("th", null, "状態"),
    /*#__PURE__*/_createElementVNode("th", null, "保留再出庫")
  ])
], -1))
const _hoisted_68 = { class: "ShippingHistoryDetail_Table_Sticky_TD1" }
const _hoisted_69 = { class: "ShippingHistoryDetail_Table_Sticky_TD2" }
const _hoisted_70 = { style: {"white-space":"nowrap"} }
const _hoisted_71 = { key: 0 }
const _hoisted_72 = { key: 0 }
const _hoisted_73 = ["onClick"]

import axios from "axios";
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { SyukkoDetailData, SyukkoDetailHeader } from "@/types/syukko";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShippingHistoryDetail',
  emits: ["showGlobalHeader", "toggleGlobalHeader"],
  setup(__props, { emit: __emit }) {

const route = useRoute();
const store = useStore();
const router = useRouter();

const emit = __emit;
emit("toggleGlobalHeader");

let detailList = ref<SyukkoDetailData[]>([]);
let headerData = ref<SyukkoDetailHeader>({} as SyukkoDetailHeader);

//詳細情報取得
const getShippingDetail = async (): Promise<void> => {
  try {
    const searchParams = `juchuNumber=${route.params.id}`;
    const res = await axios.get(
      `${store.getters["getBaseUrl"]}/syukko/shippingHistoryDetail?${searchParams}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    detailList.value.splice(0);
    detailList.value = res.data.map(
      (datailData: SyukkoDetailData) => datailData
    );
    getHeaderData(detailList.value[0]);
  } catch (error) {
    console.log(error);
  }
};
getShippingDetail();
//ヘッダ情報を抜粋して別途保持する
const getHeaderData = (datailData: SyukkoDetailData) => {
  headerData.value = { ...datailData };
};

const openTab = async (
  horyuSaiSyukkoJuchuNumber: string | null
): Promise<void> => {
  let resolvedRoute = router.resolve({
    name: "ShippingHistoryDetail",
    params: { id: horyuSaiSyukkoJuchuNumber },
  });
  window.open(
    resolvedRoute.href,
    "_blank",
    "width=1500,height=600,scrollbars=1,location=0,menubar=0,toolbar=0,status=1,directories=0,resizable=1,left=" +
      (window.screen.width - 800) / 2 +
      ",top=" +
      (window.screen.height - 450) / 2
  );
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(headerData).juchuNumber), 1)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(headerData).tourokuDate), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(headerData).client), 1)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(headerData).registrant), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(headerData).eventMei), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(headerData).joukenMei), 1)
              ]),
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createElementVNode("div", _hoisted_33, _toDisplayString(_unref(headerData).cycle), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _hoisted_36,
                _createElementVNode("div", _hoisted_37, _toDisplayString(_unref(headerData).toritugiMei), 1)
              ]),
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _createElementVNode("div", _hoisted_40, _toDisplayString(_unref(headerData).syotenMei), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _createElementVNode("div", _hoisted_45, _toDisplayString(_unref(headerData).tanzaku), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _hoisted_48,
                _createElementVNode("div", _hoisted_49, _toDisplayString(_unref(headerData).nouhinRemarks), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                _hoisted_52,
                _createElementVNode("div", _hoisted_53, _toDisplayString(_unref(headerData).sagyouRemarks), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("div", _hoisted_55, [
                _hoisted_56,
                _createElementVNode("div", _hoisted_57, _toDisplayString(_unref(headerData).toritugiSyotenCd), 1)
              ]),
              _createElementVNode("div", _hoisted_58, [
                _hoisted_59,
                _createElementVNode("div", _hoisted_60, _toDisplayString(_unref(headerData).bansen), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("div", _hoisted_62, [
                _hoisted_63,
                _createElementVNode("div", _hoisted_64, _toDisplayString(_unref(headerData).confirmedDenpyouNumber), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_65, [
      _createElementVNode("table", _hoisted_66, [
        _hoisted_67,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(detailList), (result, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              _createElementVNode("td", _hoisted_68, _toDisplayString(result.detailNumber), 1),
              _createElementVNode("td", _hoisted_69, _toDisplayString(result.syosiCd), 1),
              _createElementVNode("td", _hoisted_70, _toDisplayString(result.janCd), 1),
              _createElementVNode("td", null, _toDisplayString(result.syuppanSyosiCd), 1),
              _createElementVNode("td", null, _toDisplayString(result.title), 1),
              _createElementVNode("td", null, _toDisplayString(result.hontaiPrice), 1),
              _createElementVNode("td", null, _toDisplayString(result.juchusuu), 1),
              _createElementVNode("td", null, _toDisplayString(result.syukkosuu), 1),
              _createElementVNode("td", null, _toDisplayString(result.syoumi), 1),
              _createElementVNode("td", null, _toDisplayString(result.syoumiPrice), 1),
              _createElementVNode("td", null, _toDisplayString(result.hannyu), 1),
              _createElementVNode("td", null, _toDisplayString(result.nouhinDate), 1),
              _createElementVNode("td", null, _toDisplayString(result.orderNumber), 1),
              _createElementVNode("td", null, _toDisplayString(result.seikyuDate), 1),
              _createElementVNode("td", null, [
                (result.orderSyubetu === '1')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_71, "客注"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("td", null, _toDisplayString(result.syukkoStatus), 1),
              _createElementVNode("td", null, [
                (
                  result.syukkoStatus === '品切' &&
                  result.horyuSaiSyukkoJuchuNumber !== null
                )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                      _createElementVNode("button", {
                        class: "ShippingHistoryDetail_Button",
                        onClick: ($event: any) => (openTab(result.horyuSaiSyukkoJuchuNumber))
                      }, " 保留再出庫 ", 8, _hoisted_73)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})